import { defineStore } from "pinia";
import Services from '@/services/sutting/issuersPassportsServices'
import { mapList, mapIssuerPassport } from '@/helpers/mapFuncs'

export const useIssuersPassportsStore = defineStore("issuersPassports", {
persist: true,
state:()=>({
    issuerPassport: {},
    issuersPassports: [],
}),
getters : {
    getIssuerPassport() {
        return mapIssuerPassport(this.issuerPassport)
    },
    getIssuersPassports() {
        return this.issuersPassports.map(mapIssuerPassport)
    },
    getIssuersPassportsList() {
        return this.issuersPassports.map(mapList)
    }
},
actions : {
    /** Start Sets */
    setIssuerPassport(issuerPassport) {
        this.issuerPassport = issuerPassport
    },
    setIssuersPassports(issuersPassports) {
        this.issuersPassports = issuersPassports
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setIssuerPassport(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setIssuersPassports(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.issuersPassports.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.issuersPassports[this.issuersPassports.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.issuersPassports = this.issuersPassports.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
